import { addTypesquareForNingen } from "./_add_typesquare";
import { IS_DEBUG } from "./_constants";

const {$}=window;


function setupNewsList(){
  const {expo2025newslist}=window;
  if(!expo2025newslist){
    throw new Error("expo2025newslist is null");
  }
  
  const newsListElement=document.querySelector<HTMLElement>(".p-section-news__news-list");
  if(!newsListElement){
    throw new Error("newsListElement is null");
  }
  newsListElement.innerHTML="";
  // eslint-disable-next-line no-restricted-syntax
  for(const expo2025news of expo2025newslist){
    const newsElement=document.createElement("a");
    newsElement.classList.add("p-section-news__news");
    newsListElement.appendChild(newsElement);
    newsElement.target="_blank";
    newsElement.href=expo2025news.url;
    const mainElement=document.createElement("div");
    mainElement.classList.add("p-section-news__news-main");
    newsElement.appendChild(mainElement);
    const dateElement=document.createElement("div");
    dateElement.classList.add("p-section-news__news-date");
    mainElement.appendChild(dateElement);
    dateElement.textContent=expo2025news.date;
    const textElement=document.createElement("div");
    textElement.classList.add("p-section-news__news-text");
    mainElement.appendChild(textElement);
    textElement.innerHTML=expo2025news.html;
    const moreElement=document.createElement("div");
    moreElement.classList.add("p-section-news__news-more");
    newsElement.appendChild(moreElement);
    moreElement.textContent="more ＞";
    
  }

}

$(()=>{
  if(IS_DEBUG){
    const regexOkamura= /okamura\.co\.jp/;
    if(!document.location.href.match(regexOkamura)){
      addTypesquareForNingen();
    }
  }


  $(".p-section-hero__slick").slick({
    infinite:true,
    adaptiveHeight:true,
    centerMode: true,
    variableWidth: true,
    arrows:false,
    dots:true,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 1,
  });

  $(".p-section-exhibition-report__slick").slick({
    infinite:true,
    // adaptiveHeight:true,
    centerMode: true,
    variableWidth: true,
    arrows:true,
    dots:true,
    slidesToShow: 1,
  });

  
  setupNewsList();
});

